module.exports = __webpack_public_path__ + "static/media/flag-EN.e08499ea.svg";